import { pageNames } from "utils/Types";
import { noPlansMessageCommon } from "./NoPlansMessageCommon";

export const noPlansMessageCorpUser = {
  ...noPlansMessageCommon,
  [pageNames.suggested]: {
    label: "Suggested",
    title: "No plans are currently available - that's okay.",
    content: "You can retake the Wizard or search the Library.",
    showButton: false
    // image: AllCheckSuggestion
  },
  [pageNames.noSuggestedFilter]: {
    label: "All Plans",
    title: "No additional suggested plans are available - that's okay.",
    content: "You can retake the Wizard or search the Library.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.myPlans]: {
    label: "myPlans",
    title: "There are no plans to show for the selected Inncode(s).",

    showButton: true,
    buttonLabel: "Explore plans"
    // image: PersonSearch
  },
  [pageNames.noActivePlans]: {
    label: "onBoardingSuggestions",
    title: "Your onboarding is 100% complete",
    content: "Based on your current preferences we found some suggestions for you.",
    showButton: true,
    buttonLabel: "See Suggested plans"
    // image: PersonSearch
  },
  [pageNames.noAssignAction]: {
    label: "onBoardingAssign",
    content: "Ready to assign your first action?",
    showButton: true,
    buttonLabel: "Assign Action"
    // image: DiverseTeam
  },
  [pageNames.noReports]: {
    label: "CompletedPlanReports",
    title: `You have no Completed Plans`,
    showButton: false
    // image: PersonSearch
  },
  [pageNames.searchResultAction]: {
    label: "Individual Actions",
    title: "There are no actions for this Functional Areas.",
    content: "We are always adding the most relevant content for you so continue to check back.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.globalSearchResult]: {
    label: "Global Search",
    title: "There are currently no actions for this search.",
    content: "We are always adding new content, continue to check back.",
    showButton: false
    // image: PersonSearch2
  },
  [pageNames.aboveProperty]: {
    label: "Above Property",
    title: "No properties currently bookmarked",
    content: "",
    showButton: true
    // image: AllCheckSuggestion
  },
  [pageNames.abovePropertyPlans]: {
    label: "Above Property",
    title: "No plans currently bookmarked",
    content: "",
    showButton: false
    // image: AllCheckSuggestion
  }
};
